/* eslint-disable react/no-unescaped-entities */
import { Link } from "react-router-dom";
import blog1 from "../../assets/images/all-img/blog/blog1.png";
import blog2 from "../../assets/images/all-img/blog/blog2.png";
import blog3 from "../../assets/images/all-img/blog/blog3.png";
import blog4 from "../../assets/images/all-img/blog/blog4.png";
import blog5 from "../../assets/images/all-img/blog/blog5.png";
import blog6 from "../../assets/images/all-img/blog/blog6.png";
import arrowBlackRight from "../../assets/images/svg/arrow-black-right.svg";

import BlogPagination from "./blog-pagination";

export default function BlogPost() {
	return (
		<div className="col-xl-8 col-lg-7">
			<div className="row">
				<div className="col-xl-6 col-lg-12 col-md-6">
					<div className="fugu-blog-card wow fadeInUpX" data-wow-delay="0s">
						<div className="fugu-blog-thumb">
							<Link to={"/single-blog-light"}>
								<img src={blog1} alt="" />
							</Link>
						</div>
						<div className="fugu-blog-content">
							<div className="fugu-blog-meta">
								<ul>
									<li>
										<Link to={"/"}>Article</Link>
									</li>
									<li>
										<Link to={"/"}>August 26, 2022</Link>
									</li>
								</ul>
							</div>
							<h5>
								<Link to={"/single-blog-light"}>
									Do you need a blockchain project? Six very easy steps to verify it as wise
								</Link>
							</h5>
							<p>
								You may be fascinated by blockchain technology, hearing about all those
								ground-breaking...
							</p>
							<Link to={"/single-blog-light"}  >
								<a className="fugu-icon-btn">
									Read More <img src={arrowBlackRight} alt="" />
								</a>
							</Link>
						</div>
					</div>
				</div>
				<div className="col-xl-6 col-lg-12 col-md-6">
					<div className="fugu-blog-card wow fadeInUpX" data-wow-delay=".10s">
						<div className="fugu-blog-thumb">
							<Link to={"/single-blog-light"}>
								<img src={blog2} alt="" />
							</Link>
						</div>
						<div className="fugu-blog-content">
							<div className="fugu-blog-meta">
								<ul>
									<li>
										<Link to={"/"}>Article</Link>
									</li>
									<li>
										<Link to={"/"}>August 26, 2022</Link>
									</li>
								</ul>
							</div>
							<h5>
								<Link to={"/single-blog-light"}>
									How to build NFT marketplace here give a step-by-step guide to help you
								</Link>
							</h5>
							<p>
								An NFT marketplace is an online platform based on blockchain that allows selling and
								buying...
							</p>
							<Link to={"/single-blog-light"}  >
								<a className="fugu-icon-btn">
									Read More <img src={arrowBlackRight} alt="" />
								</a>
							</Link>
						</div>
					</div>
				</div>
				<div className="col-xl-6 col-lg-12 col-md-6">
					<div className="fugu-blog-card wow fadeInUpX" data-wow-delay=".20s">
						<div className="fugu-blog-thumb">
							<Link to={"/single-blog-light"}>
								<img src={blog3} alt="" />
							</Link>
						</div>
						<div className="fugu-blog-content">
							<div className="fugu-blog-meta">
								<ul>
									<li>
										<Link to={"/"}>Article</Link>
									</li>
									<li>
										<Link to={"/"}>August 26, 2022</Link>
									</li>
								</ul>
							</div>
							<h5>
								<Link to={"/single-blog-light"}>
									Making life of blockchain developers flawless interview with our solutions
								</Link>
							</h5>
							<p>
								The work of people responsible for consulting & analysis, the intermediaries between
								ideas...
							</p>
							<Link to={"/single-blog-light"}  >
								<a className="fugu-icon-btn">
									Read More <img src={arrowBlackRight} alt="" />
								</a>
							</Link>
						</div>
					</div>
				</div>
				<div className="col-xl-6 col-lg-12 col-md-6">
					<div className="fugu-blog-card wow fadeInUpX" data-wow-delay=".30s">
						<div className="fugu-blog-thumb">
							<Link to={"/single-blog-light"}>
								<img src={blog4} alt="" />
							</Link>
						</div>
						<div className="fugu-blog-content">
							<div className="fugu-blog-meta">
								<ul>
									<li>
										<Link to={"/"}>Article</Link>
									</li>
									<li>
										<Link to={"/"}>August 26, 2022</Link>
									</li>
								</ul>
							</div>
							<h5>
								<Link to={"/single-blog-light"}>
									Bridges between blockchains for the connecting the DeFi space one place
								</Link>
							</h5>
							<p>
								The blockchain space has been fortunate with a creativity burst that resulted in
								impressive...
							</p>
							<Link to={"/single-blog-light"}  >
								<a className="fugu-icon-btn">
									Read More <img src={arrowBlackRight} alt="" />
								</a>
							</Link>
						</div>
					</div>
				</div>
				<div className="col-xl-6 col-lg-12 col-md-6">
					<div className="fugu-blog-card wow fadeInUpX" data-wow-delay=".40s">
						<div className="fugu-blog-thumb">
							<Link to={"/single-blog-light"}>
								<img src={blog5} alt="" />
							</Link>
						</div>
						<div className="fugu-blog-content">
							<div className="fugu-blog-meta">
								<ul>
									<li>
										<Link to={"/"}>Article</Link>
									</li>
									<li>
										<Link to={"/"}>August 26, 2022</Link>
									</li>
								</ul>
							</div>
							<h5>
								<Link to={"/single-blog-light"}>
									How to deploy a hyperledger fabric for network on kubernetes networks?
								</Link>
							</h5>
							<p>
								Enterprise-className companies need secure and efficient solutions that can fluently
								scale...
							</p>
							<Link to={"/single-blog-light"}  >
								<a className="fugu-icon-btn">
									Read More <img src={arrowBlackRight} alt="" />
								</a>
							</Link>
						</div>
					</div>
				</div>
				<div className="col-xl-6 col-lg-12 col-md-6">
					<div className="fugu-blog-card wow fadeInUpX" data-wow-delay=".50s">
						<div className="fugu-blog-thumb">
							<Link to={"/single-blog-light"}>
								<img src={blog6} alt="" />
							</Link>
						</div>
						<div className="fugu-blog-content">
							<div className="fugu-blog-meta">
								<ul>
									<li>
										<Link to={"/"}>Article</Link>
									</li>
									<li>
										<Link to={"/"}>August 26, 2022</Link>
									</li>
								</ul>
							</div>
							<h5>
								<Link to={"/single-blog-light"}>
									Let's meet our blockchain projects - interview with solutions Consultant
								</Link>
							</h5>
							<p>
								Watch the interview our solutions Consultant Agnieszka Hołownia-Niedzielska who works...
							</p>
							<Link to={"/single-blog-light"}  >
								<a className="fugu-icon-btn">
									Read More <img src={arrowBlackRight} alt="" />
								</a>
							</Link>
						</div>
					</div>
				</div>
			</div>
			<BlogPagination />
		</div>
	);
}
